import { Box, Typography, Divider, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const SectionHeader = ({ 
  title, 
  subtitle, 
  variant = 'h6',
  showDivider = true,
  sx = {},
  ...props 
}) => {
  const theme = useTheme();

  return (
    <Box 
      sx={{ 
        mb: 2, 
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          left: -12,
          top: '50%',
          transform: 'translateY(-50%)',
          width: '3px',
          height: '20px',
          background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          borderRadius: '2px',
        },
        ...sx 
      }} 
      {...props}
    >
      <Typography 
        variant={variant}
        sx={{ 
          fontWeight: 600,
          color: 'text.primary',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          mb: subtitle ? 0.75 : 0,
          fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' },
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary',
            fontWeight: 400,
            fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
            opacity: 0.8,
            letterSpacing: '0.1px',
            lineHeight: 1.4,
          }}
        >
          {subtitle}
        </Typography>
      )}
      {showDivider && (
        <Divider 
          sx={{ 
            mt: 1.5,
            borderColor: alpha(theme.palette.primary.main, 0.3),
            borderWidth: '1px',
            '&:before': {
              borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            },
            '&:after': {
              borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            },
          }} 
        />
      )}
    </Box>
  );
};

export default SectionHeader;
